import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { GithubRepoAccess } from "@/modules/work/projects/integrations/github";
import { repoQuery } from "./repo/layout";

export function RepoAccessList({ repoId }) {
  const { data: repo } = useQuery(repoQuery(repoId));
  return (
    <GithubRepoAccess
      title="People"
      repositoryUrl={repo?.repository_url}
      listKey={`integrations-github-people-${repoId}`}
    />
  );
}

export default function GithubPeople() {
  const { repo_id } = useParams();
    return (
      <div className="flex-1">
        <RepoAccessList repoId={repo_id} />
      </div>
    );
}
